/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { AnyAction } from 'redux';
import { Constants } from '../../core/constants';
import { Log } from '../../core/logging/Log';
import { VisibilityState } from '../visibilityevents/visibilitystate';
import { AppState } from './appstate';
import {
    clearSystemHealthIntervalAction,
    setSystemHealthIntervalAction,
} from './healthstats.actions';
import { CLEAR_SYSTEM_HEALTH_INTERVAL, SET_SYSTEM_HEALTH_INTERVAL } from './healthstats.types';

const initialState: {
    systemHealthInterval: any;
} = {
    systemHealthInterval: null,
};

const TAG = 'SystemHealthStats';

const systemInfo = (window as any)?.KaveriApp?.PlatformApis?.systemInfo;

const systemHealthStatsReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_SYSTEM_HEALTH_INTERVAL:
        case CLEAR_SYSTEM_HEALTH_INTERVAL:
            return {
                ...state,
                systemHealthInterval: payload.systemHealthInterval,
            };

        default:
            return state;
    }
};

export const setSystemHealthStatsInterval = () => (dispatch: Function, getState: Function) => {
    const { visibilityEvents, healthStats } = getState();
    const { visibilityState } = visibilityEvents;
    const { systemHealthInterval } = healthStats;
    if (visibilityState === VisibilityState.ON_RESUME) {
        if (systemHealthInterval === null) {
            dispatch(logSystemHealthStats);
            const systemHealthIntervalId = setInterval(() => {
                dispatch(logSystemHealthStats());
            }, Constants.SYSTEM_HEALTH_EVENT_INTERVAL);
            dispatch(setSystemHealthIntervalAction(systemHealthIntervalId));
        }
    }
};

export const clearSystemHealthStatsInterval = () => (dispatch: Function, getState: Function) => {
    const { systemHealthInterval } = getState().healthStats;
    if (systemHealthInterval) {
        clearInterval(systemHealthInterval);
        dispatch(clearSystemHealthIntervalAction());
    }
};

export const logSystemHealthStats = () => (dispatch: Function, getState: Function) => {
    const { screens, visibilityEvents } = getState();
    const { screenController } = screens;
    const { visibilityState } = visibilityEvents;

    // TODO : Added Minimum Actual may have more.
    const customData = <JSON>(<unknown>{
        MemTotal: systemInfo?.getTotalMemory(),
        MemAvailable: systemInfo?.getAvailableMemory(),
        screenName: screenController,
        appState:
            visibilityState === VisibilityState.ON_RESUME
                ? AppState.FOREGROUND
                : AppState.BACKGROUND,
    });
    Log.i(TAG, 'data', customData);
    Diagnostics.info(TAG, 'data', customData);
};

export default systemHealthStatsReducer;
